import { Timeslot } from "./timeslot";
import { Athlete } from "./athlete";
import { AgendaComment } from "./agenda-comment";

interface AgendaData {
  id?: number;
  athleteId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  timeslots?: Timeslot[];
  athlete?: Athlete;
  agendaComments?: AgendaComment[];
}

export class Agenda {
  public static getNonTranslatableFields(): string[] { return ['id', 'athleteId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'athleteId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  athleteId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  timeslots?: Timeslot[];
  athlete?: Athlete;
  agendaComments?: AgendaComment[];

  public static fromAPI(data: AgendaData): Agenda {
    if (data.timeslots) {
      data.timeslots = Timeslot.fromAPIList(data.timeslots);
    }
    if (data.athlete) {
      data.athlete = Athlete.fromAPI(data.athlete);
    }
    if (data.agendaComments) {
      data.agendaComments = AgendaComment.fromAPIList(data.agendaComments);
    }
    return new Agenda(data);
  }

  public static fromAPIList(data: AgendaData[]): Agenda[] {
    return data.map((item: AgendaData) => Agenda.fromAPI(item));
  }

  constructor({id, athleteId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              timeslots, athlete, agendaComments, rights} : AgendaData) {
    this.id = id;
    this.athleteId = athleteId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.timeslots = timeslots;
    this.athlete = athlete;
    this.agendaComments = agendaComments;

    this.rights = rights;
  }

  public toJson(): Object {
    return {
      id: this.id,
      athleteId: this.athleteId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
